const keywords = [
  "潘金莲电影",
  "故事原型",
  "历史真实形象",
  "角色分析",
  "野史解读",
  "与原著区别",
  "影视形象演变",
];

const stats = [
  { value: "6", label: "代表影视作品" },
  { value: "6", label: "形象演变阶段" },
  { value: "4", label: "角色分析视角" },
  { value: "2", label: "原著文本源流" },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20traditional%20Chinese%20opera%20scene%20with%20dramatic%20deep%20red%20and%20gold%20lighting%2C%20silhouette%20of%20a%20woman%20in%20flowing%20classical%20hanfu%20beneath%20glowing%20paper%20lanterns%2C%20ink-wash%20painting%20texture%2C%20misty%20atmospheric%20depth%2C%20warm%20crimson%20and%20charcoal%20tones%2C%20cinematic%20theatrical%20composition%2C%20dark%20negative%20space%20at%20center&width=1920&height=1080&seq=panjinlian-hero&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pt-32 pb-24 text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/20 px-4 py-1.5 backdrop-blur-sm">
          <span className="h-[6px] w-[6px] rounded-full bg-accent-400"></span>
          <span className="font-label text-xs tracking-[0.2em] text-background-100">
            专题导览 · 一页读懂
          </span>
        </div>

        <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-background-50">
          潘金莲电影：从故事原型到银幕形象
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
          这里整理与潘金莲相关的影视作品，从故事原型与历史真实形象的讨论，到角色分析、野史解读，
          再到电影与原著区别、影视形象演变。沿着页面往下，你可以一步步看清：
          她为何被反复拍成电影，又为何每一版都不太一样。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#works"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-film-line"></i>
            浏览经典作品
          </a>
          <a
            href="#prototype"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 font-label text-sm font-medium text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
          >
            <i className="ri-book-2-line"></i>
            了解故事原型
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          {keywords.map((k) => (
            <span
              key={k}
              className="rounded-full bg-background-50/10 border border-background-50/20 px-3 py-1 font-label text-xs text-background-100"
            >
              {k}
            </span>
          ))}
        </div>

        <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 border-t border-background-50/15 pt-8">
          {stats.map((s) => (
            <div key={s.label}>
              <dt className="font-heading text-2xl md:text-3xl font-bold text-accent-300">
                {s.value}
              </dt>
              <dd className="mt-1 font-label text-xs md:text-sm text-background-100/80">
                {s.label}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}